import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  CompanyVerificationRequest,
  CompanyVerificationRequestPayload,
} from '@core/tellent-company-verification-types';
import { TellentHttpApiService } from '@core/tellent-http-legacy';

@Injectable({
  providedIn: 'root',
})
export class CompanyVerificationHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);

  public fetch(): Observable<CompanyVerificationRequest> {
    return this.httpApi.get('/verification-request').pipe(map(response => response.data));
  }

  public verify(
    payload: Partial<CompanyVerificationRequestPayload>,
  ): Observable<CompanyVerificationRequest> {
    return this.httpApi.patch('/verify', {}, payload).pipe(map(response => response.data));
  }
}
